import styled from '@emotion/styled'
import NoteCounter from 'components/NoteCounter'
import { Button, DrawerDivider } from 'components/patterns'
import { themeColor } from 'utils/styles'

export const StyledNoteCounter = styled(NoteCounter)`
  font-weight: bold;
  margin-top: 0px;
  font-size: 14px;
`

export const NotesSection = styled.div`
  border-top: 1px solid ${themeColor('grey')};
  padding: 16px;
  margin: 0 -16px;
  flex: 1;
  display: flex;
  height: calc(100% - 125px);
  flex-direction: column;
  margin-top: 16px;
`

export const NotesSectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TotalNotesCountText = styled.h4`
  font-size: 14px;
  font-weight: bold;
  margin: 0;
`

export const StyledDrawerDivider = styled(DrawerDivider)`
  margin: 20px 0;
`

export const SortButton = styled(Button)`
  margin: 0 !important;
  height: 14px !important;
  padding: 8px !important;
  display: flex;
  gap: 10px;
  font-size: 14px !important;
  height: 30px !important;
  line-height: 15px !important;
  &:hover {
    color: ${themeColor('blackSecondary')} !important;
  }

  ${({ disabled }) =>
    disabled &&
    `
    background: ${themeColor('greySecondary')} !important;
    border: 1px solid ${themeColor('grey')} !important;
    color: ${themeColor('slateLight')} !important;
  `}
`
export const NotesList = styled.ul`
  padding: 0;
  margin: 0;
  margin-top: 16px;
  list-style: none;
`
export const NotesListItem = styled.li`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 16px 0;
  border-bottom: thin solid ${themeColor('grey')};
  &:first-child {
    padding-top: 0;
  }
`
export const NotesHeader = styled.div`
  display: flex;
  justify-content: space-between;
`
export const NotesTitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`
export const NotesTitle = styled.h6`
  font-size: 12px;
  font-weight: bold;
  color: ${themeColor('blackSecondary')};
  margin: 0;
`
export const NotesPostedTimeString = styled.span`
  font-size: 12px;
  color: ${themeColor('blackSecondary')};
`
export const NotesString = styled.div`
  font-size: 14px;
  color: ${themeColor('blackSecondary')};
  word-wrap: break-word;
`
